import React, { useState, useCallback } from 'react';
import { Sidebar } from './Sidebar';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const openSidebar = useCallback(() => setSidebarOpen(true), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <div className="app">
      {/* Mobile backdrop overlay */}
      <div
        className={`sidebar-overlay${sidebarOpen ? ' visible' : ''}`}
        onClick={closeSidebar}
      />

      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      <main className="main">
        {/* Mobile topbar with hamburger button */}
        <div className="mobile-topbar">
          <button className="hamburger" onClick={openSidebar} aria-label="Menü öffnen">
            <span />
            <span />
            <span />
          </button>
          <img src="/assets/logo.svg" alt="Rubin Real Estate" className="mobile-logo" style={{ height: 28 }} />
        </div>

        {children}
      </main>
    </div>
  );
}
